import { render, staticRenderFns } from "./BaixasRepasses.vue?vue&type=template&id=6a9761cc&scoped=true&"
import script from "./baixasRepasses.js?vue&type=script&lang=js&"
export * from "./baixasRepasses.js?vue&type=script&lang=js&"
import style0 from "./BaixasRepasses.vue?vue&type=style&index=0&id=6a9761cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9761cc",
  null
  
)

export default component.exports